import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-full max-h-full" }

import { Ref, ref, watch } from 'vue';
import { RouteLocationNormalizedLoaded, RouteParams, useRoute } from 'vue-router';
import { ComponentException } from '@/exceptions/component-exception';
import ItemList from '@/components/ItemList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListView',
  setup(__props) {

const route: RouteLocationNormalizedLoaded = useRoute();

if (!route.params.mainCategory || !route.params.subCategory) {
  throw new ComponentException('Required route parameters mainCategory or subCategory are empty');
}

const mainCategory: Ref<number> = ref(Number(route.params.mainCategory));
const subCategory: Ref<number> = ref(Number(route.params.subCategory));

watch(
  (): RouteParams => {
    return route.params;
  },
  (): void => {
    mainCategory.value = Number(route.params.mainCategory);
    subCategory.value = Number(route.params.subCategory);
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ItemList, {
      "main-category": mainCategory.value,
      "sub-category": subCategory.value
    }, null, 8, ["main-category", "sub-category"])
  ]))
}
}

})